<div class="change-plan-container">
    <p class="change-plan">{{programDisplayData?.changePlan?.changePlanText}}</p>
    <div class="plan-info-container">
        <div class="plan-text">
            <span class="sr-only">graphic info icon</span>
            <span aria-hidden="true">
                <img alt="info icon image" class="info-icon"
                     src="ocsp-web-ui/dist/assets/images/default_msg_info_icon.svg">
            </span>
            <div>
                <span>{{programDisplayData?.changePlan?.planTextOne}}</span>
                <span><b> {{governmentAssisted}} {{nonSelectedSubscriptionType}} {{programDisplayData?.changePlan?.plan}} </b></span>
                <span>{{programDisplayData?.changePlan?.planTextTwo}}</span>
                <span aria-hidden="true"> {{currentPlanExpiryDate}}</span> 
                <span class="sr-only">{{getCurrentPlanExpiryDate(currentPlanExpiryDate)}}</span>.
            </div>
        </div>
    </div>
</div>

